import { ResourceHelperService } from '../resource-helper.service';

/**
 * A dataservice that provides operations for decoded itso message translation requests
 */
export class DecodedItsoMessageTranslationRequestService {
  private resource: InterACT.Interfaces.IResource<InterACT.Interfaces.UsageEvents.TranslationToUsageEventRequestsResponse>;

  constructor($resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.resource = $resource('api/translation-to-usage-event-requests/:id');
  }


  /**
   * Function to retrieve a list of decoded itso message translation requests
   *
   * @param page The number of the page of data to be retrieved
   * @param perPageCount The number of items per page to be retrieved
   * @param query the query to execute against the dataset
   * @returns A http promise
   */
  public getList(page: number, perPageCount: number, query?: string): ng.IPromise<InterACT.Interfaces.UsageEvents.TranslationToUsageEventRequestsResponse> {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, query);
    return this.resource.get(options).$promise;
  }
}
